import { useState } from "react";
import { Avatar, Box, Rating, Typography } from "@mui/material";
import { getUserPhotoSrc } from "../utils/utils";

type UserPanelProps = {
  id: string;
  name: string;
  rating?: number;
};

const UserPanel = ({ id, name, rating }: UserPanelProps) => {
  const [hovered, setHovered] = useState(false);

  return (
    <Box
      sx={{
        borderRadius: "1rem",
        height: "3rem",
        width: "100%",
        display: "flex",
        alignItems: "center",

        background: hovered ? "#E6E8EA" : "#ffffff",
        cursor: hovered ? "pointer" : "default",
        justifyContent: "space-between",
      }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      // onClick={onSelect}
    >
      <Box sx={{
        
        display: "flex",
        alignItems: "center",

        
      }}>
        <Avatar alt="u" src={getUserPhotoSrc(id)} />
        &nbsp;
        <Typography>{name}</Typography>
      </Box>
      {rating ? (<Rating readOnly value={rating} precision={0.1}></Rating>) : null}
      
    </Box>
  );
};

export default UserPanel;
